import * as UserActionTypes from "../actions/user";
import history from "../utils/history";
import initialState from "../reducers/initialState";

import { errorResponseHandler } from "../utils/error-utils";
import { platform } from "os";

export default (state = initialState.user, action) => {
  const { payload, type } = action;

  switch (type) {
    case UserActionTypes.SIGN_IN:
    case UserActionTypes.SIGN_IN_PENDING:
      return { ...state, login_loading: true };

    case UserActionTypes.SIGN_IN_REJECTED:
      return {
        ...state,
        login_loading: false,
        error: true,
        errorMessage: payload.data
      };

    case UserActionTypes.SIGN_IN_FULFILLED:
      sessionStorage.setItem("user", JSON.stringify(payload.data));
      return {
        ...state,
        login_loading: false,
        login_success: true,
        userInfo: payload.data
      };

    /* SIGNING IN FROM QUOTATION AREA */
    case UserActionTypes.QUOTE_SIGN_IN:
      return { ...state };

    case UserActionTypes.QUOTE_SIGN_IN_PENDING:
      return { ...state };

    case UserActionTypes.QUOTE_SIGN_IN_REJECTED:
      return {
        ...state,
        modalError: true,
        errorMessage: payload.response.data
      };

    case UserActionTypes.QUOTE_SIGN_IN_FULFILLED:
      sessionStorage.setItem("user", JSON.stringify(payload.data));
      window.location.reload();

      return { ...state, userInfo: payload.data };

    case UserActionTypes.SIGN_OUT:
      history.push("/login-register");
      window.location.reload();

      return { ...state, userInfo: null };

    case UserActionTypes.REGISTER:
    case UserActionTypes.REGISTER_PENDING:
      return { ...state };

    case UserActionTypes.REGISTER_FULFILLED:
      return { ...state, registered: true, registerationInfo: payload.data };

    case UserActionTypes.REGISTER_REJECTED:
      console.log(payload);
      return {
        ...state,
        registered: false,
        ...errorResponseHandler(payload, "RegisterUser")
      };

    case UserActionTypes.CREATE_USER:
    case UserActionTypes.CREATE_USER_PENDING:
      return { ...state };

    case UserActionTypes.CREATE_USER_REJECTED:
      return {
        ...state,
        error: true,
        ...errorResponseHandler(payload, "CreateUser")
      };
    //return { ...state,  error:true, errorMessage: payload.response.data, ...errorResponseHandler(payload,"CreateUser") }

    case UserActionTypes.CREATE_USER_FULFILLED:
      // let createdUser=payload.data;
      // return Object.assign({}, state,{
      //     filteredUsers:[
      //         createdUser,
      //         ...state.filteredUsers
      //     ],
      //     success:true
      // });
      return { ...state, user_created: payload.data, success: true };

    case UserActionTypes.CREATE_USER_ADMIN:
    case UserActionTypes.CREATE_USER_ADMIN_PENDING:
      return { ...state };

    case UserActionTypes.CREATE_USER_ADMIN_REJECTED:
      return {
        ...state,
        error: true,
        ...errorResponseHandler(payload, "CreateUserAdmin")
      };
    //return { ...state, error:true, errorMessage: payload.response.data }

    case UserActionTypes.CREATE_USER_ADMIN_FULFILLED:
      return { ...state, success: true, successMessage: payload.data.Info };

    case UserActionTypes.CHANGE_PASSWORD:
    case UserActionTypes.CHANGE_PASSWORD_PENDING:
      return { ...state };

    case UserActionTypes.CHANGE_PASSWORD_REJECTED:
      return { ...state, error: true, errorMessage: payload.response.data };

    case UserActionTypes.CHANGE_PASSWORD_FULFILLED:
      return { ...state, success: true, successMessage: payload.data.success };

    case UserActionTypes.RESET_PASSWORD:
    case UserActionTypes.RESET_PASSWORD_PENDING:
      return { ...state };

    case UserActionTypes.RESET_PASSWORD_REJECTED:
      return { ...state, ...errorResponseHandler(payload, "ResetPassword") };

    case UserActionTypes.RESET_PASSWORD_FULFILLED:
      return { ...state, success: true, successMessage: payload.data.success };

    case UserActionTypes.UPDATE_USER_PROFILE:
    case UserActionTypes.UPDATE_USER_PROFILE_PENDING:
      return { ...state, update_profile_loading: true };

    case UserActionTypes.UPDATE_USER_PROFILE_REJECTED:
      return {
        ...state,
        error: true,
        update_profile_loading: false,
        errorMessageUpdateProfile: payload.response.data.error
      };

    case UserActionTypes.UPDATE_USER_PROFILE_FULFILLED:
      const { first_name, last_name, email, phone, photo } = payload.data;

      const userInfo = {
        ...state.userInfo,
        name: `${first_name} ${last_name}`,
        email,
        phone,
        photo
      };

      sessionStorage.setItem("user", JSON.stringify(userInfo));

      return {
        ...state,
        update_user_loading: false,
        successMessageUpdateProfile: "Profile updated",
        userInfo
      };

    case UserActionTypes.LIST_ADMIN_PENDING:
      return {
        ...state,
        adminError: false,
        adminSuccess: false,
        adminsLoading: true
      };

    case UserActionTypes.LIST_ADMIN_FULFILLED:
      return {
        ...state,
        adminError: false,
        adminSuccess: true,
        adminsLoading: false,
        admins: payload.data,
        successMessage: "Admins loaded successfully"
      };

    case UserActionTypes.LIST_ADMIN_REJECTED:
      return {
        ...state,
        adminError: true,
        adminSuccess: false,
        adminsLoading: false,
        ...errorResponseHandler(payload, "ListAdmins")
      };

    case UserActionTypes.FETCH_USER:
    case UserActionTypes.FETCH_USER_PENDING:
      return { ...state, user_loading: true, filteredUsers: [] };

    case UserActionTypes.FETCH_USER_REJECTED:
      return {
        ...state,
        userError: true,
        error: true,
        errorMessage: payload.response.data
      };

    case UserActionTypes.FETCH_USER_FULFILLED:
      return { ...state, user_loading: false, filteredUsers: payload.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js